<template>
    <div class="container">
        <div class="cart-title text-center p-5">{{ trans[localLanguage]['lista_preferiti'] }}</div>
        <p class="text-center">{{ trans[localLanguage]['invia_richiesta_full'] }}</p>
        <div class="p-2">
            <!-- {{ [filtered_articles] }} -->
            
            <!-- {{ [localCartItems] }} -->
            <div class="row flex container-principale">
                <div class="col-9 colonna-principale">
                    <div v-if="filtered_articles.length<1 && filtered_accessories.length<1">
                        <p class="text-center">{{ trans[localLanguage]['nessun_articolo'] }}</p>
                    </div>
                    <div v-else>
                        <div class="row pt-1 pb-2 heading-list-prod">
                            <div class="col-5">{{ trans[localLanguage]['prodotto'] }}</div>
                            <div class="col-2">{{ trans[localLanguage]['quantita'] }}</div>
                            <div class="col-5">{{ trans[localLanguage]['note'] }}</div>
                            <div class="col-1"></div>
                        </div>
                        <div v-for="(item,index) in filtered_articles" :key="item.id" class="row py-4 item-list">
                            <div class="col-5 colonna-tabella">
                                <div style="display:flex">
                                    <div style="display:flex; flex-direction:column; justify-content: center;">
                                        <img
                                        v-if="item.val('image')"
                                        class="img-fluid"
                                        :src="item.val('image').link({ x: 120, ext: 'webp' })"
                                        alt=""
                                        />
                                        <div v-else-if="localCartItems">
                                            <div v-for="(cartItem, index3) in localCartItems" :key="index3">
                                                <div v-if="cartItem.article_id == item.id" style="display:flex; flex-direction:column; justify-content:center; align-items:center">
                                                    <img
                                                        v-if="cartItem.image"
                                                        class="img-fluid"
                                                        :src="cartItem.image"
                                                        alt=""
                                                        />
                                                </div>
                                                <!-- {{ cartItem.article_id }} -->
                                            </div>

                                        </div>

                                        <img
                                            v-else
                                            class="img-fluid"
                                            src="collezioni/placeholder.png"
                                            alt=""
                                            style="max-width:120px"
                                        />
                                    </div>
                                    <div style="display:flex; flex-direction:column; justify-content: center;">
        
                                        <div style="width:100%; padding-left:20px; padding-right:20px">
                                            <div>
                                            {{ item.relSync('modelli')[0].val("nome") }} -
                                            {{ item.relSync('modelli')[0].val("tipo_parete") }} -
                                            {{ item.relSync('modelli')[0].val("nome") }}
                                            </div>
                                        </div>
                                        <div style="width:100%;  padding-left:20px; padding-right:20px">
                                        COD:
                                        <span id="" style="font-weight: bold">{{
                                            item.val("codice_esploso")
                                        }}</span>
                                        </div>
                                        <div>
                                            <div style="width:100%;  padding-left:20px; padding-right:20px">
                                                <template v-for="(cartItem, index4) in localCartItems" :key="index4" >
                                                    <div v-if="cartItem.article_id == item.id && cartItem.colore" style="width:100%" >
                                                        <!-- {{ cartItem.note }} -->
                                                        <!-- <input type="textarea" v-model="cartItem.note" > -->
                                                        {{ trans[localLanguage]['colore'] }}
                                                        {{ cartItem.colore }}
                                                        <div style="width:100%" v-if="cartItem?.colore_image">
                                                            <img :src="cartItem.colore_image" style="width:100%; max-width:50px;">
                                                            
                                                        </div>
                                                    </div>
                                                    <!-- {{ cartItem.article_id }} -->
                                                </template>
                                            </div>
                                        </div>
                                    </div>
        
                                </div>
                            </div>
                            <div class="col-2 colonna-tabella" style="display:flex; flex-direction:row; justify-content:center; align-items:center">
                                <div v-for="(cartItem, index2) in localCartItems" :key="index2">
                                    <div v-if="cartItem.article_id == item.id" style="display:flex; flex-direction:column; justify-content:center; align-items:center">
                                        <div @click="incrementQuantity(index2)">
                                            <img class="img-function" src="../public/icone/expand_less.png" >
                                        </div>
                                        <div>
                                            {{ cartItem.quantity }}
                                        </div>
                                        <div @click="decrementQuantity(index2 )">
                                            <img class="img-function" src="../public/icone/expand_more.png" >
                                        </div>
                                    </div>
                                    <!-- {{ cartItem.article_id }} -->
                                </div>
                            </div>
                            <div class="col-4 colonna-tabella" style="display:flex; flex-direction:row; justify-content:center; align-items:center">
                                <template v-for="(cartItem, index2) in localCartItems" :key="index2" >
                                    <div v-if="cartItem.article_id == item.id" style="width:100%" >
                                        <!-- {{ cartItem.note }} -->
                                        <!-- <input type="textarea" v-model="cartItem.note" > -->
                                        <textarea style="width:100%; border:1px solid #ccc; padding:10px;" v-model="cartItem.note" @input="update" rows="5"></textarea>
                                    </div>
                                    <!-- {{ cartItem.article_id }} -->
                                </template>
                            </div>
                            <div class="col-1 colonna-tabella" style="display:flex; flex-direction:row; justify-content:center; align-items:center">
                                <a @click=removeArticleFromCart(index) class="remove-product" style="border:1px solid black; cursor:pointer; border-radius:45px;"> <img style="max-width:40px;" src="../public/icone/close.png" > </a>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="filtered_accessories.length>0">
                        <div v-for="(item, index) in filtered_accessories" :key="item.id" class="row py-4 item-list">
                            <div class="col-5">
                                <div style="display:flex">
                                    <div style="display:flex; flex-direction:column; justify-content: center;">
                                        <img
                                        v-if="item.val('image')"
                                        class="img-fluid"
                                        :src="item.val('image').link({ x: 120, ext: 'webp' })"
                                        alt=""
                                        />
                                        <div v-else-if="localCartItems">
                                            <div v-for="(cartItem, index3) in localCartItems" :key="index3">
                                                <div v-if="cartItem.article_id == item.id" style="display:flex; flex-direction:column; justify-content:center; align-items:center">
                                                    <img
                                                        v-if="cartItem.image"
                                                        class="img-fluid"
                                                        :src="cartItem.image"
                                                        alt=""
                                                        />
                                                </div>
                                            </div>

                                        </div>

                                        <img
                                            v-else
                                            class="img-fluid"
                                            src="collezioni/placeholder.png"
                                            alt=""
                                            style="max-width:120px"
                                        />
                                    </div>
                                    <div style="display:flex; flex-direction:column; justify-content: center;">
        
                                        <div style="width:100%; padding-left:20px; padding-right:20px">
                                            <div>
                                            {{ item.val("nome") }} -
                                            {{ item.val("tipo_parete") }} -
                                            {{ item.val("nome") }}
                                            </div>
                                        </div>
                                        <div style="width:100%;  padding-left:20px; padding-right:20px">
                                        COD:
                                        <span id="" style="font-weight: bold">{{
                                            item.val("codice_base")
                                        }}</span>
                                        </div>
                                        <div>
                                            <div style="width:100%;  padding-left:20px; padding-right:20px">
                                                <template v-for="(cartItem, index4) in localCartItems" :key="index4" >
                                                    <div v-if="cartItem.article_id == item.id && cartItem.colore" style="width:100%" >
                                                        {{ trans[localLanguage]['colore'] }}
                                                        {{ cartItem.colore }}
                                                        <div style="width:100%" v-if="cartItem?.colore_image">
                                                            <img :src="cartItem.colore_image" style="width:100%; max-width:50px;">

                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
        
                                </div>
                            </div>
                            <div class="col-2">
                                <div v-for="(cartItem, index2) in localCartItems" :key="index2">
                                    <div v-if="cartItem.article_id == item.id" style="display:flex; flex-direction:column; justify-content:center; align-items:center">
                                        <div @click="incrementQuantity(index2)">
                                            <img class="img-function" src="../public/icone/expand_less.png" >
                                        </div>
                                        <div>
                                            {{ cartItem.quantity }}
                                        </div>
                                        <div @click="decrementQuantity(index2)">
                                            <img class="img-function" src="../public/icone/expand_more.png" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4" ref="" style="display:flex; flex-direction:row; justify-content:center; align-items:center">
                                <template v-for="(cartItem, index2) in localCartItems" :key="index2" >
                                    <div v-if="cartItem.article_id == item.id" style="width:100%">
                                        <textarea style="width:100%; border:1px solid #ccc; padding:10px;" v-model="cartItem.note" @input="update" rows="5"></textarea>
                                    </div>
                                </template>
                            </div>
        
            
                            <div class="col-1" style="display:flex; flex-direction:row; justify-content:center; align-items:center">
                                <a @click=removeAccessoryFromCart(index) class="remove-product" style="border:1px solid black; cursor:pointer; border-radius:45px;"> <img style="max-width:40px;" src="../public/icone/close.png" > </a>
                            </div>
                        </div>
                    </div> -->

                </div>
                <div class="col-3 colonna-principale" style="padding-top:40px;">
                    <div style="background-color:#f1f1f1" class="contenitore-lista">
                        <div style="padding:20px 40px; " class="lista-funzionalita">
                            <div class="lista-1">
                                <div  v-if="filtered_articles.length > 0" class="pulsante-carrello" @click="popUpFormRequestVisibility = true">
                                    <div>
                                        <img src="../public/icone/mail.png" >
                                    </div>
                                    <div>
                                        {{ trans[localLanguage]['invia_richiesta'] }}
                                    </div>
                                </div>
                                <div  v-if="filtered_articles.length > 0" class="pulsante-carrello" @click="requestPreventivo()">
                                    <div>
                                        <img src="../public/icone/pdf-image.png" >
                                    </div>
                                    <div>
                                        {{ trans[localLanguage]['crea_pdf'] }}
                                    </div>
                                </div>
                                <!-- <div @click="generaSchedaTecnicaPerMail()">test mail con generazione</div> -->
                            </div>
                            <div class="pulsante-carrello" style="margin-top:60px; background-color:unset; border:none;" @click="svuotaCarrello()">
                                <div>
                                    <img src="../public/icone/delete.png" >
                                </div>
                                <div>
                                    {{ trans[localLanguage]['svuota_lista'] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
        <!-- {{getLanguage()}} -->
        <NotificationPopUp :message="notificationMessage" :visible="notificationVisibility"></NotificationPopUp>
        <CartFormRequest  :visible="popUpFormRequestVisibility" @close="popUpFormRequestVisibility = false" @sendMail="sendEmailPreventivo"></CartFormRequest>
    </div>
    
</template>

<script>
import axios from 'axios';
import { defineComponent } from "@vue/runtime-core";
import { Schema } from "onpage-js";
import NotificationPopUp from "./components/NotificationPopUp.vue";
import CartFormRequest from "./components/CartFormRequest.vue";

export default defineComponent({
  props: {
    schema: {
      type: Schema,
      required: true,
    },
    pagine_web: {
      required: true,
    }
  },
  components: {
    NotificationPopUp,
    CartFormRequest,
  },
  mounted(){
    if(this.schema.lang == 'en'){
      this.notificationMessage= 'Product removed'
      this.localLanguage = this.schema.lang 
    } else {
        this.notificationMessage= 'Prodotto rimosso'
        this.localLanguage = this.schema.lang 
    }
    // this.getLanguage()
  },
  data() {
    return {
        localLanguage: 'en',
        popUpFormRequestVisibility: false,
        notificationVisibility: false,
        notificationMessage: 'Prodotto rimosso',
        allOrders: [],
        filtered_articles: [],
        filtered_accessories: [],
        localCartItems: [],
        trans: {
            'it': {
            lista_preferiti: 'LISTA DEI PREFERITI',
            invia_richiesta_full: 'Invia una richiesta preventivo dei prodotti inseriti nella tua lista, ti risponderemo entro 48 ore lavorative.',
            prodotto: 'PRODOTTO',
            quantita: 'QUANTITÀ',
            note: 'NOTE PRODOTTO',
            invia_richiesta: 'Invia richiesta preventivo',
            crea_pdf: 'Crea PDF da stampa',
            svuota_lista: 'Svuota la lista',
            nessun_articolo: 'Non ci sono articolo selezionati!',
            colore:'Colore ',
        },
        'en': {
                lista_preferiti: 'FAVORITES LIST',
            invia_richiesta_full: 'Send a request for quotation of the products included in your list, we will reply within 48 working hours.',
            prodotto: 'PRODUCT',
            quantita: 'QUANTITY',
            note: 'PRODUCT NOTES',
            invia_richiesta: 'Send quote request',
            crea_pdf: 'Create PDF to print',
            svuota_lista: 'Empty the list',
            nessun_articolo: 'There are no selected items!',
            colore:'Colore ',
            }
        }
    };
  },
  async created() {
    this.loadFromStorage()
    this.refreshArticoli();
    this.refreshAccessori();
  },
  computed: {
    articoli_query(){
      const schema = this.schema;
      if(!schema) return;
      const c = schema.query("articoli").with("modelli");
      return c;
    },
    accessori_query(){
      const schema = this.schema;
      if(!schema) return;
      const c = schema.query("modelli").with("articoli");
      return c;
    }
  },
  methods: {
    async sendEmailPreventivo(form){
        
        // let pdfData = await this.generaSchedaTecnicaPerMail();


        let formData = form
        console.log('dati da spedire')
        console.log(this.filtered_articles)
        console.log(this.filtered_accessories)
        console.log(formData)
        // formData.attachment = pdfData;
        let lista_dati_email = []
        for (let index = 0; index < this.filtered_articles.length; index++) {
            const article = this.filtered_articles[index];
            let immagine_articolo = ''
            if(article.val('image')){
                immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
            }
            let nome = article.relSync('modelli')[0].val("nome") 
            let tipo_parete = article.relSync('modelli')[0].val("tipo_parete") 
            let codice = article.val("codice_esploso") 
            let product_data= {
                'image' : immagine_articolo, 
                'name' : nome,
                'tipo_parete' : tipo_parete,
                'codice': codice
            }
            for (let index2 = 0; index2 < this.localCartItems.length; index2++) {
                const cart_item = this.localCartItems[index2];
                console.log(cart_item)
                if(cart_item.article_id == article.id){
                    product_data.quantity = cart_item.quantity
                    product_data.note = cart_item.note
                    product_data.art_img = cart_item.image
                    product_data.art_color = cart_item.colore
                    product_data.art_color_img = cart_item.colore_image
                }
            }
            lista_dati_email.push(product_data)
        }
        // for (let index3 = 0; index3 < this.filtered_accessories.length; index3++) {
        //     const article = this.filtered_accessories[index3];
        //     let immagine_articolo = ''
        //     if(article.val('image')){
        //         immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
        //     }
        //     let nome = article.val("nome") 
        //     let tipo_parete = article.val("tipo_parete") 
        //     let codice = article.val("codice_base") 
        //     let product_data= {
        //         'image' : immagine_articolo, 
        //         'name' : nome,
        //         'tipo_parete' : tipo_parete,
        //         'codice': codice
        //     }
        //     for (let index4 = 0; index4 < this.localCartItems.length; index4++) {
        //         const cart_item = this.localCartItems[index4];
        //         if(cart_item.article_id == article.id){
        //             product_data.quantity = cart_item.quantity
        //             product_data.note = cart_item.note
        //             product_data.art_img = cart_item.image
        //             product_data.art_color = cart_item.colore
        //             product_data.art_color_img = cart_item.colore_image
        //         }
        //     }
        //     lista_dati_email.push(product_data)
        // }
        console.log('lista_dati_email', lista_dati_email)
        formData.product_list = JSON.stringify(lista_dati_email)
        axios.post('https://21st-gardenart.com/invio-mail/mail/send_mail.php', formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
          console.log(response);
          // Puoi fare qualcosa con la risposta qui, ad esempio mostrare un messaggio di successo
            this.popUpFormRequestVisibility = false

            this.notificationMessage= 'Preventivo inviato'

            if(this.schema.lang == 'en'){
                this.notificationMessage= 'Quote has been sent'
            } else {
                this.notificationMessage= 'Preventivo inviato'
            }
            this.notificationVisibility = true;
            setTimeout(() => {
                this.notificationVisibility = false;
            }, 700); // il popup scomparirà dopo 3 secondi
        })
        .catch(error => {
          console.error(error);
            // this.popUpFormRequestVisibility = false
          // Puoi fare qualcosa con l'errore qui, ad esempio mostrare un messaggio di errore
        });
        axios.post('https://21st-gardenart.com/invio-mail/mail/send_mail_client.php', formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
          console.log(response);
          // Puoi fare qualcosa con la risposta qui, ad esempio mostrare un messaggio di successo
            // this.popUpFormRequestVisibility = false

            this.notificationMessage= 'Preventivo inviato'

            if(this.schema.lang == 'en'){
                this.notificationMessage= 'Quote has been sent'
            } else {
                this.notificationMessage= 'Preventivo inviato'
            }
            this.notificationVisibility = true;
            setTimeout(() => {
                // this.notificationVisibility = false;
            }, 700); // il popup scomparirà dopo 3 secondi
        })
        .catch(error => {
          console.error(error);
            // this.popUpFormRequestVisibility = false
          // Puoi fare qualcosa con l'errore qui, ad esempio mostrare un messaggio di errore
        });
        console.log('form', form)
    },
    
    requestPreventivo(){
        let formData = {}
        console.log('dati da spedire')
        console.log(this.filtered_articles)
        console.log(this.filtered_accessories)

        let lista_dati_email = []
        for (let index = 0; index < this.filtered_articles.length; index++) {
            const article = this.filtered_articles[index];
            let immagine_articolo = ''
            if(article.val('image')){
                immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
            }
            let nome = article.relSync('modelli')[0].val("nome") 
            let tipo_parete = article.relSync('modelli')[0].val("tipo_parete") 
            let codice = article.val("codice_esploso") 
            let product_data= {
                'image' : immagine_articolo, 
                'name' : nome,
                'tipo_parete' : tipo_parete,
                'codice': codice
            }
            for (let index2 = 0; index2 < this.localCartItems.length; index2++) {
                const cart_item = this.localCartItems[index2];
                console.log(cart_item)
                if(cart_item.article_id == article.id){
                    product_data.quantity = cart_item.quantity
                    product_data.note = cart_item.note
                    product_data.art_img = cart_item.image
                    product_data.art_color = cart_item.colore
                    product_data.art_color_img = cart_item.colore_image
                }
            }
            lista_dati_email.push(product_data)
        }
        // for (let index3 = 0; index3 < this.filtered_accessories.length; index3++) {
        //     const article = this.filtered_accessories[index3];
        //     let immagine_articolo = ''
        //     if(article.val('image')){
        //         immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
        //     }
        //     let nome = article.val("nome") 
        //     let tipo_parete = article.val("tipo_parete") 
        //     let codice = article.val("codice_base") 
        //     let product_data= {
        //         'image' : immagine_articolo, 
        //         'name' : nome,
        //         'tipo_parete' : tipo_parete,
        //         'codice': codice
        //     }
        //     for (let index4 = 0; index4 < this.localCartItems.length; index4++) {
        //         const cart_item = this.localCartItems[index4];
        //         if(cart_item.article_id == article.id){
        //             product_data.quantity = cart_item.quantity
        //             product_data.note = cart_item.note
        //             product_data.art_img = cart_item.image
        //             product_data.art_color = cart_item.colore
        //             product_data.art_color_img = cart_item.colore_image
        //         }
        //     }
        //     lista_dati_email.push(product_data)
        // }
        console.log('lista_dati_email', lista_dati_email)
        formData.product_list = JSON.stringify(lista_dati_email)

        let form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://lithos.it/pdfCarrello-21stGarden/gestione_stampa.php';
        form.target = '_blank';

        for (let key in formData) {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = formData[key];
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
    },
    async generaSchedaTecnicaPerMail(){
        let formData = {}
        console.log('dati da spedire')
        console.log(this.filtered_articles)
        console.log(this.filtered_accessories)

        let lista_dati_email = []
        for (let index = 0; index < this.filtered_articles.length; index++) {
            const article = this.filtered_articles[index];
            let immagine_articolo = ''
            if(article.val('image')){
                immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
            }
            let nome = article.relSync('modelli')[0].val("nome") 
            let tipo_parete = article.relSync('modelli')[0].val("tipo_parete") 
            let codice = article.val("codice_esploso") 
            let product_data= {
                'image' : immagine_articolo, 
                'name' : nome,
                'tipo_parete' : tipo_parete,
                'codice': codice
            }
            for (let index2 = 0; index2 < this.localCartItems.length; index2++) {
                const cart_item = this.localCartItems[index2];
                console.log(cart_item)
                if(cart_item.article_id == article.id){
                    product_data.quantity = cart_item.quantity
                    product_data.note = cart_item.note
                    product_data.art_img = cart_item.image
                    product_data.art_color = cart_item.colore
                    product_data.art_color_img = cart_item.colore_image
                }
            }
            lista_dati_email.push(product_data)
        }
        // for (let index3 = 0; index3 < this.filtered_accessories.length; index3++) {
        //     const article = this.filtered_accessories[index3];
        //     let immagine_articolo = ''
        //     if(article.val('image')){
        //         immagine_articolo = article.val('image').link({ x: 120, ext: 'webp' })
        //     }
        //     let nome = article.val("nome") 
        //     let tipo_parete = article.val("tipo_parete") 
        //     let codice = article.val("codice_base") 
        //     let product_data= {
        //         'image' : immagine_articolo, 
        //         'name' : nome,
        //         'tipo_parete' : tipo_parete,
        //         'codice': codice
        //     }
        //     for (let index4 = 0; index4 < this.localCartItems.length; index4++) {
        //         const cart_item = this.localCartItems[index4];
        //         if(cart_item.article_id == article.id){
        //             product_data.quantity = cart_item.quantity
        //             product_data.note = cart_item.note
        //             product_data.art_img = cart_item.image
        //             product_data.art_color = cart_item.colore
        //             product_data.art_color_img = cart_item.colore_image
        //         }
        //     }
        //     lista_dati_email.push(product_data)
        // }
        console.log('lista_dati_email', lista_dati_email)
        formData.product_list = JSON.stringify(lista_dati_email)

        let response = await axios.post('https://lithos.it/mail-21stGarden/gestione_stampa_mail.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        console.log('pdf ricevuto come stringa', response.data)
        return btoa(response.data);

        // let form = document.createElement('form');
        // form.method = 'POST';
        // form.action = 'https://21st-gardenart.com/stampa-pdf/gestione_stampa.php';
        // form.target = '_blank';

        // for (let key in formData) {
        //     let input = document.createElement('input');
        //     input.type = 'hidden';
        //     input.name = key;
        //     input.value = formData[key];
        //     form.appendChild(input);
        // }
        // document.body.appendChild(form);
        // form.submit();
    },
    getLanguage() {
        this.localLanguage =  localStorage.getItem('selectedLanguage')
        return localStorage.getItem('selectedLanguage');
    },
    svuotaCarrello(){
        this.localCartItems = [];
        this.filtered_accessories = [];
        this.filtered_articles= [];
        this.updateLocalStorage()
    },
    update() {
        this.updateLocalStorage()
    //   clearTimeout(this.saveTimeout);
    //   this.saveTimeout = setTimeout(this.save, 1000); // salva dopo 1 secondo
    },
    incrementQuantity(indiceArticoloCarrello){
        this.localCartItems[indiceArticoloCarrello].quantity += 1
        this.updateLocalStorage()
    },
    decrementQuantity(indiceArticoloCarrello){
        if(this.localCartItems[indiceArticoloCarrello].quantity > 1){
            this.localCartItems[indiceArticoloCarrello].quantity -= 1
        } 
        this.updateLocalStorage()
    },
    removeArticleFromCart(indiceArticoloCarrello){
        let indiceArrayLocale = this.localCartItems.findIndex(obj => obj.article_id === this.filtered_articles[indiceArticoloCarrello].id);
        this.filtered_articles.splice(indiceArticoloCarrello, 1)
        this.localCartItems.splice(indiceArrayLocale, 1)
        this.notificationMessage= 'Prodotto rimosso'
        if(this.schema.lang == 'en'){
        this.notificationMessage= 'Product removed'
        } else {
        this.notificationMessage= 'Prodotto rimosso'
        }
        this.notificationVisibility = true;
        setTimeout(() => {
            this.notificationVisibility = false;
        }, 700); // il popup scomparirà dopo 3 secondi
        this.updateLocalStorage()
    },
    removeAccessoryFromCart(indiceAccessorioCarrello){
        console.log(this.filtered_accessories)
        console.log(indiceAccessorioCarrello)
        console.log(this.filtered_articles.length)
        let indiceArrayLocale = this.localCartItems.findIndex(obj => obj.article_id === this.filtered_accessories[indiceAccessorioCarrello].id);
        this.filtered_accessories.splice(indiceAccessorioCarrello, 1)
        console.log(indiceArrayLocale)
        this.localCartItems.splice(indiceArrayLocale, 1)
        this.notificationMessage= 'Prodotto rimosso'
        if(this.schema.lang == 'en'){
        this.notificationMessage= 'Product removed'
        } else {
        this.notificationMessage= 'Prodotto rimosso'
        }
        this.notificationVisibility = true;
        setTimeout(() => {
            this.notificationVisibility = false;
        }, 700); // il popup scomparirà dopo 3 secondi
        this.updateLocalStorage()
    },
    updateLocalStorage(){
        localStorage.setItem('cart_items', JSON.stringify(this.localCartItems));
    },
    async refreshArticoli(){
      let lista_articoli_onpage = await this.articoli_query.all();
      this.filtered_articles = lista_articoli_onpage
      console.log('articoli onpage', this.filtered_articles)
        // Preleva gli ID di tutti gli articoli nel carrello
        let cartItemIds = this.localCartItems.map(item => item.article_id);
        console.log('id elementi', cartItemIds)
        console.log('----', lista_articoli_onpage[0].relSync('modelli')[0])
        // Filtra solo gli articoli il cui id è contenuto nell'array di id
        this.filtered_articles = lista_articoli_onpage.filter(article => cartItemIds.some(id => id === article.id));
        console.log( 'Articoli da Onpage', this.filtered_articles)
    },
    async refreshAccessori(){
      let lista_articoli_accessori_onpage = await this.articoli_query.all();
      this.filtered_accessories = lista_articoli_accessori_onpage
      console.log('accessori onpage', this.filtered_accessories)
        // Preleva gli ID di tutti gli articoli nel carrello
        let cartItemIds = this.localCartItems.map(item => item.article_id);
        console.log('id elementi', cartItemIds)
        console.log('----', lista_articoli_accessori_onpage[0].relSync('modelli')[0])
        // Filtra solo gli articoli il cui id è contenuto nell'array di id
        this.filtered_accessories = lista_articoli_accessori_onpage.filter(article => cartItemIds.some(id => id === article.id));
        console.log( 'Accessori da Onpage', this.filtered_accessories)
    },
    loadFromStorage(){
        this.allOrders = [];
        if(localStorage.getItem('cart_items')){
            let lista_articoli_da_local_storage = JSON.parse(localStorage.getItem('cart_items'))
            this.localCartItems = lista_articoli_da_local_storage
        }
        
    },
    // DeleteFromSorage(index){
    //     console.log(index)
    //     localStorage.removeItem(index)
    //     this.loadFromStorage()
    // }
  },
  watch: {}

});
</script>

<style scoped>
.img-fluid{
    max-width:180px
}

.img-function{
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;
    cursor:pointer
}
.img-function:hover{
    transform: scaleX(1.15) scaleY(1.15);
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;

}
@media only screen and (max-width: 1000px) {
    .container-principale{
        flex-direction: column;
    }
    .colonna-principale{
        width:100%
    }
    .lista-funzionalita{
        display: flex; 
        flex-direction:row;
        justify-content: space-between;
    }
    .pulsante-carrello{
        margin-top:20px !important;
        margin-right:20px;
        background-color: #f1f1f1;
        padding:20px 40px;
    }
    .contenitore-lista{
        background-color: white !important;
    }
    .lista-1{
        display: flex;
        flex-direction:row;
    }
}
@media only screen and (max-width: 680px) {
    .container-principale{
        flex-direction: column;
    }
    .colonna-principale{
        width:100%
    }
    .lista-funzionalita{
        display: flex; 
        flex-direction:column;
        justify-content: space-between;
    }
    .pulsante-carrello{
        margin-top:20px !important;
        margin-right:20px;
        background-color: #f1f1f1;
        padding:20px 40px;
    }
    .contenitore-lista{
        background-color: white !important;
    }
    .lista-1{
        display: flex;
        flex-direction:column;
    }
    .colonna-tabella{
        width:100%;
    }
    .heading-list-prod{
        display:none;
    }
}
</style>
<style>
.pulsante-carrello{
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    padding:10px;
    background-color: #fff;
    margin-top:10px;
    margin-bottom:10px;
    border:1px solid white;
    border-radius:7px;
    text-align:center;
    cursor:pointer;
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;

}
.pulsante-carrello:hover{
    transform: scaleX(1.05) scaleY(1.05);
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;

}
.cart-title{
    font-size: 45px;
    text-transform: uppercase;
}
.heading-list-prod,.list-prod{
    text-transform: uppercase;
    border-bottom: 1px solid #ccc;
}
.item-list{
    border-bottom: 1px solid #ccc;
    min-height: 140px;
}
.remove-product{
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;
}
.remove-product:hover{
    transform: scaleX(1.15) scaleY(1.15);
    transition: transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,transform 300ms ease 0ms,box-shadow 300ms ease 0ms;
}
</style>